import { makeStyles, Theme } from '@material-ui/core/styles';
import { indigo, pink } from '@material-ui/core/colors';
import { normalizeUnits } from 'moment-timezone';

const useStyles = makeStyles((theme: Theme) => ({
  '@global': {
    '.block-picker': {
      boxShadow: 'none !important',
      borderRadius: '0 !important',
    },
    '.block-picker > div': {
      borderRadius: '0 !important',
    },
  },
  root: {
    flexGrow: 1,
    minWidth: 1320,
    maxWidth: 1800,
  },
  createRoot: {
    maxWidth: '600px',
    padding: '3px',
  },
  tabBarWrap: {
    borderBottom: '1px solid #e8e8e8',
  },
  table: {
    minWidth: 650,
  },
  infoTextField: {
    width: '100%',
    paddingBottom: theme.spacing(1),
  },
  createAutomatedCollectionWrap: {
    width: '940px',
  },

  contentSettingWrap: {
    marginBottom: theme.spacing(3),
    marginRight: theme.spacing(3),
    padding: theme.spacing(3),
  },
  sectionTitle: {
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  flexSectionTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  chip: {
    marginLeft: theme.spacing(1.5),
  },
  colorPicker: {
    border: '1px solid #e8e8e8',
  },
  radioButtonGroups: {
    flexDirection: 'row',
  },

  formControl: {
    margin: theme.spacing(1),
    minWidth: 96,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  queryTextArea: {
    width: '100%',
    fontSize: '0.75rem',
    letterSpacing: '-0.1px',
    padding: theme.spacing(1),
    borderColor: '#e8e8e8',
    marginBottom: theme.spacing(1.2),
    fontFamily: 'Roboto Mono',
  },
  queryButton: {
    width: '100px',
  },
  testResultImage: {
    width: '45px',
    height: '80px',
    objectFit: 'cover',
    backgroundColor: '#e8e8e8',
    marginRight: theme.spacing(2),
  },
  testResultWriter: {
    color: theme.palette.text.hint,
  },
  testResultStoryId: {
    marginTop: theme.spacing(1.2),
    marginBottom: theme.spacing(),
  },
  testResultWrap: {
    height: '418px',
    overflowY: 'scroll',
    border: '1px solid #e8e8e8',
    '&::-webkit-scrollbar': {
      WebkitAppearance: 'none',
    },

    '&::-webkit-scrollbar:vertical': {
      width: '8px',
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '8px',
      border: '0 none',
      backgroundColor: 'rgba(0, 0, 0, .6)',
    },
  },
  testResultDescription: {
    marginLeft: theme.spacing(1),
  },
  testResultDescriptionError: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    color: theme.palette.error.main,
  },
  testResultNoResult: {
    height: '418px',
    border: '1px solid #e8e8e8',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  nextFireTitle: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  mainButton: {
    marginRight: theme.spacing(1),
    '&:last-child': {
      marginRight: 0,
    },
  },
  testButtonProgress: {
    color: indigo[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  submitButtonProgress: {
    color: pink[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  tableRow: {
    cursor: 'pointer',
  },
  tableRowHighlited: {
    backgroundColor: `${theme.palette.primary.main}18`,
  },
  noDataBox: {
    height: '200px',
  },
  paper: {
    padding: theme.spacing(3),
    marginBottom: 16,
  },
  row: {
    alignItems: 'center',
    paddingBottom: theme.spacing(3),
  },
  topAlignColumn: {
    height: '100%',
    alignSelf: 'flex-start',
  },
  testButton: {
    width: '80px',
    marginLeft: theme.spacing(1),
  },
  nextSegmentInfoBox: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  nextSegmentTitle: {
    paddingBottom: theme.spacing(1),
  },
  longTextField: {
    minWidth: '310px',
    marginLeft: '24px',
    marginRight: '6px',
  },
  mediumTextField: {
    width: '120px',
    marginLeft: '24px',
    marginRight: '6px',
  },
  smallTextField: {
    width: '50px',
    marginLeft: '24px',
    marginRight: '6px',
  },
  maxAttendanceText: {
    display: 'flex',
    alignItems: 'center',
  },
  bottomButtons: {
    width: '100%',
    flex: 1,
    justifyContent: 'flex-end',
  },
  nestedTabsRoot: {
    minHeight: 36,
    borderBottom: '0 none',
  },
  nestedTabRoot: {
    minHeight: 36,
  },
  nestedTabWrapper: {
    position: 'absolute',
    fontSize: '13px !important',
    zIndex: 1,
  },
  flowKeySelectMenu: {
    whiteSpace: 'normal',
  },
  dualTableWrap: {
    position: 'relative',
    minHeight: 187,
    borderRadius: 6,
    border: 'solid 1px #e6e6e6',
    backgroundColor: '#ffffff',
    flexWrap: 'nowrap',
    '& th': {
      padding: '16px 4px',
      boxSizing: 'content-box',
    },
    '& td': {
      padding: '16px 4px',
      boxSizing: 'content-box',
    },
    '& th:first-child': {
      paddingLeft: '8px',
    },
    '& th:last-child': {
      paddingRight: '8px',
    },
    '& td:first-child': {
      paddingLeft: '8px',
    },
    '& td:last-child': {
      paddingRight: '8px',
    },
  },
  dualTableWrap16: {
    '& th': {
      padding: '16px 8px',
      boxSizing: 'content-box',
    },
    '& td': {
      padding: '16px 8px',
      boxSizing: 'content-box',
    },
    '& th:first-child': {
      paddingLeft: '16px',
    },
    '& th:last-child': {
      paddingRight: '16px',
    },
    '& td:first-child': {
      paddingLeft: '16px',
    },
    '& td:last-child': {
      paddingRight: '16px',
    },
  },
  dualTableLeftWrap: {
    minHeight: 270,
    flex: 1,
  },
  dualTableLeftWrapExpand: {
    width: '100%',
    minHeight: 270,
  },
  dualTableLeftHeader: {
    backgroundColor: '#eee',
  },
  dualTableRightWrap: {
    borderLeft: '1px solid rgba(224, 224, 224, 1)',
    flex: '0 0 320px',
  },
  dualTableRightBox: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  dualTableRightHeader: {
    backgroundColor: '#eee',
    padding: '15px 24px 15px',
    lineHeight: '1rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
  },
  dualTableRightHeaderText: {
    color: 'rgba(0,0,0, 0.54)',
    fontSize: 12,
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  dualTableRightContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: '10px 0',
  },
  thinTable: {
    '& td': {
      paddingTop: 2,
      paddingBottom: 2,
    },
  },
  noBorderRow: {
    '& td': {
      borderBottom: 'none',
    },
  },
  lastNoBorder: {
    '& tbody:last-child td': {
      borderBottom: 'none',
    },
  },
  limitLine: {
    lineHeight: 0,
    '& span': {
      lineHeight: 1.2,
      display: 'block',
      height: 13,
      overflow: 'visible',
      marginTop: '-8px',
      textAlign: 'center',
    },
  },
  searchWrap: {
    padding: '0 24px 6px',
  },
  listBox: {
    flex: 1,
    position: 'relative',
  },
  listWrap: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    overflow: 'auto',
    padding: '0 16px 0 16px',
  },
  displayFeaturedItem: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  displayFeaturedTitle: {
    fontWeight: 500,
    lineHeight: 1,
  },
  displayTitle: {
    whiteSpace: 'nowrap',
    maxWidth: 220,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'flex',
    alignItems: 'center',
  },
  displayTitleWrap: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  titleText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  displayAddButton: {
    padding: '4px',
  },
  segButton: {
    fontWeight: 'normal',
    width: 75,
  },
  childSegName: {
    flexGrow: 1,
  },
  childSegId: {
    minWidth: 32,
    flexGrow: 1,
    textAlign: 'right',
  },
  overLine: {
    lineHeight: '24px',
    width: 24,
    height: 24,
    borderRadius: 20,
    display: 'inline-block',
    '&:hover': {
      backgroundColor: '#DDD',
    },
  },
  segNumberColumn: {
    width: 110,
  },
  segCurationBtnColumn: {
    width: 110,
  },
  segCurationInfoColumn: {
    width: 200,
  },
  listTitle: {
    fontSize: 16,
    fontWeight: 500,
    padding: 20,
  },
  cellMore: {
    width: 40,
  },
  cellStatus: {
    width: 70,
  },
  cellPriority: {
    width: 66,
  },
  cellId: {
    width: 40,
  },
  cellTrackingId: {
    width: 72,
  },
  cellAbtestId: {
    width: 62,
  },
  cellLinked: {
    width: 36,
  },
  cellStories: {
    width: 40,
  },
  cellCover: {
    width: 63,
  },
  cellDateTime: {
    width: 128,
    whiteSpace: 'nowrap',
  },
  cellDateTimeDouble: {
    width: 310,
    whiteSpace: 'nowrap',
  },
  cellDelete: {
    width: 36,
  },
  abtestModalRoot: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleWrap: {},
  modalPaper: {
    position: 'relative',
    width: 760,
    minHeight: 310,
    maxHeight: 800,
    padding: '24px 20px',
  },
  modalCloseButton: {
    position: 'absolute',
    right: 8,
    top: 10,
  },
  coverImage: {
    width: 98,
    height: 55,
    borderRadius: 1,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    margin: '0 auto',
  },
  coverImageSmall: {
    width: 53,
    height: 30,
    borderRadius: 1,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    margin: '0 auto',
  },
  variantsListScroll: {
    overflow: 'auto',
    height: 500,
    marginBottom: 20,
    paddingBottom: 5,
  },
  addVariantWrap: {
    position: 'relative',
  },
  addVariantButton: {
    position: 'absolute',
    right: 20,
    marginTop: 10,
    fontSize: '13px',
    fontWeight: 'normal',
    padding: '7px 21px',
  },
  normalizedButton: {
    fontSize: 13,
    fontWeight: 'normal',
  },
  tbodyWithAbTest: {
    '& tr:first-child td': {
      borderBottomWidth: 0,
    },
    '& tr:last-child td': {
      borderBottomWidth: 1,
    },
  },
  trWithAbTest: {
    '& td': {
      borderBottom: 'none',
    },
  },
  trOfAbTest: {
    '& td': {
      paddingBottom: 20,
    },
  },
  abtestInfoBox: {
    backgroundColor: '#f5f5f5',
    padding: 20,
  },
  abtestInfoSection: {
    fontSize: 15,
    fontWeight: 500,
    marginBottom: 6,
  },
  abtestInfoVariant: {
    marginTop: 15,
    paddingTop: 15,
    borderTop: '1px solid #dedede',
  },
  abtestInfoVariantTitle: {
    fontWeight: 500,
    fontSize: 13,
    marginRight: 12,
  },
  abtestInfoVariantTrackingId: {
    fontSize: 13,
    marginRight: 12,
  },
  abtestInfoDate: {
    fontSize: 13,
    color: '#666666',
  },
  nowrap: {
    whiteSpace: 'nowrap',
  },
  nowrapDots: {
    display: 'block',
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  twolineDots: {
    overflow: 'hidden',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },
  abtestMidtitle: {
    fontSize: '15px',
    fontWeight: 500,
  },
  abtestCountBox: {
    display: 'flex',
    width: 121,
    alignContent: 'center',
  },
  abtestCountBoxLeft: {
    flex: '0 0 102px',
    fontSize: '12px',
  },
  abtestCountBoxRight: {
    flex: '0 0 23px',
  },
  abtesVariantWrap: {
    marginTop: 25,
  },
  abtestVariantTitle: {
    display: 'flex',
    marginBottom: 15,
  },
  popoverLink: {
    cursor: 'pointer',
    color: 'inherit',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  popoverOpener: {
    color: 'inherit',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
    cursor: 'context-menu',
  },
  curationScheduleListTitle: {
    maxWidth: 400,
  },
  curationScheduleListTitleCollection: {
    display: 'block',
  },
  dateInput: {
    minWidth: 120,
  },
  internalTitleEmphasize: {
    fontWeight: 500,
    color: theme.palette.primary.main,
    display: 'block',
  },
  twoLine: {
    wordBreak: 'break-all',
    overflow: 'hidden',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },
  segmentInfoBox: {
    padding: 15,
    fontSize: '15px',
    marginBottom: 16,
  },
  segmentInfoItem: {
    width: 100,
    marginRight: 20,
  },

  linkCountText: {
    display: 'inline-block',
    cursor: 'pointer',
    padding: '4px',
    '&:hover': {
      fontWeight: 'bold',
      color: theme.palette.primary.main,
      textDecoration: 'underline',
    },
  },

  greyButton: {
    borderColor: '#C8C8C8',
    color: '#777777',
  },
}));

export default useStyles;

export const colors: { [key: string]: string } = {
  story: '#ff008a',
  link: '#4a90e2',
  collection: '#9013fe',
};

export const statusColors: { [key: string]: string } = {
  activated: '#4051b5',
  scheduled: '#09c178',
  completed: '#e0e0e0',
};
